<template>
    <section class="content">

        <div class="row center-block">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-header">
                        <h3 class="box-title">Contacto</h3>
                    </div>
                    <div class="box-body">
                        <div class="row col-md-12 entrada">
                            <div class = "col-md-4">
                                <label> Alias </label>
                                <el-input placeholder="Nombre"></el-input>
                            </div>
                            <div class = "col-md-4">
                                <label> Email </label>
                                <el-input placeholder="Apellido"></el-input>
                            </div>
                            <div class = "col-md-4">
                                <label> Email </label>
                                <el-input  placeholder="Email"></el-input>
                            </div>
                        </div>
                        <div class="row col-md-12 entrada">
                            <div class = "col-md-4">
                                <label> Compañia </label>
                                <el-input placeholder="Telefono"></el-input>
                            </div>
                            <div class = "col-md-4">
                                <label> Estado </label>
                                <br>
                                <el-radio-group >
                                    <el-radio-button label="prospective">Solicitado</el-radio-button>
                                    <el-radio-button label="inactive">Inactivo</el-radio-button>
                                    <el-radio-button label="active">Activo</el-radio-button>
                                    <el-radio-button label="inactive">Rechazado</el-radio-button>
                                    <el-radio-button label="inactive">Supendido</el-radio-button>
                                    <el-radio-button label="inactive">Sin Acción</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="col-md-12 entrada" style="margin-top:20px;">
                            <div class = "col-md-3">Guardar</button>
                                <button class="btn btn-secondary">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: 'Settings',
    components: {
    },
    data (router) {
      return {
        section: 'CommentDetail',
        loading: '',
        c: this.$route.query.c
      }
    },
    computed: {
      datetime () {
        return new Date()
      }
    },
    methods: {
    }
  }
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }


</style>



// WEBPACK FOOTER //
// ContactDetail.vue?687bebd0